for (const element of document.querySelectorAll("form")) {
	element.addEventListener("submit", (event) => {
		if (event.target.classList.contains("is-submitting")) {
			event.preventDefault();
		}

		event.target.classList.add("is-submitting");
	});
}
